import React from "react";
import { useSelector } from "react-redux";

import { i18, trb } from "@utilities";
import {
  InputFormField,
  SelectFormField,
  DateFormField
} from "@components/FormField/HookFormFields";
import { selectAvailableCountryOptions, selectDocTypeOptions } from "@redux";
import { HalfWidthInputWrapper } from "@components";

export const ClientCeoDocs = ({ control }) => {
  const availableCountries = useSelector(selectAvailableCountryOptions);
  const availableDocTypes = useSelector(selectDocTypeOptions);

  return (
    <>
      <HalfWidthInputWrapper>
        <SelectFormField
          control={control}
          name="clientCeo.0.data.clientCeoIdDocType"
          title={trb(i18.Labels.ClientCeoIdDocType)}
          options={availableDocTypes}
          optionsLabel="label"
          optionsValue="value"
          isSearchable
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <InputFormField
          control={control}
          name="clientCeo.0.data.clientCeoDocNo"
          title={trb(i18.Labels.ClientCeoDocNo)}
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <SelectFormField
          control={control}
          name="clientCeo.0.data.clientCeoDocCountry"
          title={trb(i18.Labels.ClientCeoDocCountry)}
          options={availableCountries}
          optionsLabel="label"
          optionsValue="value"
          isSearchable
          defaultValue="LT"
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <DateFormField
          control={control}
          name="clientCeo.0.data.clientCeoDocIssueDate"
          title={trb(i18.Labels.ClientCeoDocIssueDate)}
          maxDate={new Date()}
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <DateFormField
          control={control}
          name="clientCeo.0.data.clientCeoDocValidDate"
          title={trb(i18.Labels.ClientCeoDocValidDate)}
          minDate={new Date()}
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <InputFormField
          control={control}
          name="clientCeo.0.data.clientCeoDocIssuePlace"
          title={trb(i18.Labels.ClientCeoDocIssuePlace)}
        />
      </HalfWidthInputWrapper>
    </>
  );
};
